import { render, staticRenderFns } from "./DistributionSetting.vue?vue&type=template&id=92941f64&"
import script from "./DistributionSetting.vue?vue&type=script&lang=js&"
export * from "./DistributionSetting.vue?vue&type=script&lang=js&"
import style0 from "./DistributionSetting.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports